import { fetchApi } from './api';
import type { SalesTeam, SalesTeamConfigData } from '../types/salesTeamConfig';

export const salesTeamConfigApi = {
    getData: () =>
        fetchApi<SalesTeamConfigData>('/sales-team-config/data'),

    assignManager: (salesManagerId: string, salesTeamId: number) =>
        fetchApi<{ salesManagerId: string; salesTeamId: number }>(
            '/sales-team-config/assign',
            {
                method: 'POST',
                body: JSON.stringify({ salesManagerId, salesTeamId }),
            }
        ),

    unassignManager: (salesManagerId: string) =>
        fetchApi<void>(
            `/sales-team-config/assign/${encodeURIComponent(salesManagerId)}`,
            { method: 'DELETE' }
        ),

    createTeam: (salesTeamName: string, salesTeamDescription: string | null) =>
        fetchApi<SalesTeam>(
            '/sales-team-config/teams',
            {
                method: 'POST',
                body: JSON.stringify({ salesTeamName, salesTeamDescription }),
            }
        ),

    updateTeam: (teamId: number, salesTeamName: string, salesTeamDescription: string | null, isActive?: boolean) =>
        fetchApi<SalesTeam & { isActive: boolean }>(
            `/sales-team-config/teams/${teamId}`,
            {
                method: 'PUT',
                body: JSON.stringify({ salesTeamName, salesTeamDescription, isActive }),
            }
        ),
};
